import React, { Fragment } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../../styles/diario.scss'
import moment from "moment";

const Ato = (props) => {

    moment.locale('pt');
    moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ],
        weekdays: [
            "Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"
        ]
    });

    const url1 = `/transparencia${props.ato.arquivo}`;

    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                    <Card.Header><h5>Ato Oficial de Governo Nº {props.ato.numAto} de {moment(props.ato.dataAto).utc(false).format('dddd, DD [de] MMMM [de] YYYY')}</h5></Card.Header>
                    <Card.Body>
                        <Fragment>
                            <p>{props.ato.descricao}</p>
                            <p>O documento a seguir trata-se de uma {props.ato.categoria}</p>
                            <a href={url1} target="_blank" rel="noreferrer">
                                <Button type="button" variant="primary">Ver Documento</Button>
                            </a>
                            <br />
                            <br />
                        </Fragment>

                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Ato;